import { isEnglish } from 'features/applicationPage/helpers';
import { RuleProps } from '../../../types/application.d';

export const SECT_APPLICANT = 'applicant-details';
export const SECT_ADDRESS = 'address-details';
export const ORGANISATION_DETAILS = 'organisation-details';

export const TITLE_DETAILS = 'title-details';

export const TITLE_DETAILS_FIELDS = [
    {
        sectionID: TITLE_DETAILS,
        sectionName: 'Title Details',
        fieldList: [
            {
                id: 'title',
                label: 'Title',
                type: 'text',
                rule: { required: true, charLength: 500 },
                span: 6
            },
            {
                id: 'romanized-title',
                label: 'Romanised Title',
                type: 'text',
                rule: {
                    required: true,
                    charLength: 500,
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (!isEnglish(currentValue as string)) {
                            return 'Only English characters are allowed.';
                        }
                    }
                },
                span: 6
            },
            {
                id: 'language',
                apiID: 'VGLanguage',
                label: 'Language',
                type: 'dropdown',
                rule: {
                    required: true
                },
                span: 6
            },
            {
                id: 'quantity',
                label: 'Quantity',
                type: 'number',
                rule: {
                    required: true
                },
                span: 6
            },
            {
                id: 'format',
                apiID: 'DeclarationFormat',
                label: 'Format',
                type: 'dropdown',
                rule: {
                    required: true
                },
                span: 6
            },
            {
                id: 'country-of-publication',
                apiID: 'VGCountry',
                label: 'Country of Publication',
                type: 'dropdown',
                rule: {
                    required: true
                },
                span: 6
            },
            {
                id: 'software-category',
                apiID: 'SoftwareCategory',
                label: 'Software Category',
                type: 'dropdown',
                rule: {
                    required: true
                },
                span: 6
            },
            {
                id: 'declarant-remarks',
                label: 'Declarant Remarks',
                type: 'longText',
                rule: { required: true, charLength: 500 },
                span: 12
            }
        ]
    }
];

export const DECLARATION_OF_INTERACTIVE_SOFTWARE_DETAILS_FIELDS = [
    {
        sectionID: TITLE_DETAILS,
        sectionName: 'Title Details',
        fieldList: [
            {
                id: 'title',
                label: 'Title',
                type: 'text',
                rule: { required: true, charLength: 500 },
                span: 6
            },
            {
                id: 'romanized-title',
                label: 'Romanised Title',
                type: 'text',
                rule: {
                    required: true,
                    charLength: 500,
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (!isEnglish(currentValue as string)) {
                            return 'Only English characters are allowed.';
                        }
                    }
                },
                span: 6
            },
            {
                id: 'language',
                apiID: 'Language',
                label: 'Language',
                type: 'dropdown',
                rule: {
                    required: true
                },
                span: 6
            },
            {
                id: 'quantity',
                label: 'Quantity',
                type: 'number',
                rule: {
                    required: true
                },
                span: 6
            },
            {
                id: 'format',
                apiID: 'Format',
                label: 'Format',
                type: 'dropdown',
                rule: {
                    required: true
                },
                span: 6
            },
            {
                id: 'country-of-publication',
                apiID: 'Country',
                label: 'Country of Publication',
                type: 'dropdown',
                rule: {
                    required: true
                },
                span: 6
            },
            {
                id: 'software-category',
                apiID: 'Sotware Category',
                label: 'Sotware Category',
                type: 'dropdown',
                rule: {
                    required: true
                },
                span: 6
            },
            {
                id: 'declarant-remarks',
                label: 'Declarant Remarks',
                type: 'longText',
                rule: { required: true, charLength: 500 },
                span: 12
            }
        ]
    }
];
